import React, { useEffect, useState } from "react";
import { Field, FormikProvider, Form, useFormik, ErrorMessage } from "formik";
import * as DESUI from "react-bootstrap";
import Menubar from "../Menubar";
import { store } from "../../App";
import MasterService from "../../Services/MasterService";
import { AiFillFileExcel, AiOutlineSearch, } from "react-icons/ai";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import autoTable from "jspdf-autotable";
import {  Row, Col, Container,Button } from "react-bootstrap";
import allowNumbersOnly, { generatePdf, exportToExcel, datetime } from "../utils/commonFunctions";
import KpiService from "../../Services/KpiService";
import useAlert from "../Alert/useAlert";
import AlertModal from "../Alert/AlertModal";
import { FaRegSave } from "react-icons/fa";

export default function Populationreport() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
  const [searchText1, setSearch1] = useState("");
 

  let username = localStorage.getItem("username");
  let roleid = localStorage.getItem("catid");
  const formik = useFormik({
    initialValues: {
        cfms_id: ""
     
    },

  })
const [employeedata, setemployeedata] = useState();
const [uniqueYears, setUniqueYears] = useState({});
const[currentdate,setcurrentdate] =useState('');
  const[currenttime,setcurrenttime] =useState('');
 

  useEffect(() => {
   datetime(setcurrentdate,setcurrenttime);
   let params = {
    userId: username,
    ...((roleid === "113"|| roleid === "119")&& { districtId: localStorage.getItem("districtid") })
  };
  
KpiService.populationReport(params)
.then((res) => {
  store.dispatch({ type: "HIDE_SPINNER" });
  
  console.log("API Response:", res.data.SDESC);
  if(res.data.SCODE==="01"){
    setemployeedata(res.data?.SDESC);
    const uniqueFinYears = [...new Set(res.data.SDESC.map(item => item.fin_year).filter(Boolean))];
    setUniqueYears(uniqueFinYears);}
    else{
      showAlertMessage(res.data.SDESC,"warning")
    }

 
})
.catch((error) => {
  store.dispatch({ type: "HIDE_SPINNER" });
  console.error("Error in populationReport:", error); // ✅ Log catch
});
  }, []);


      const filteredDataa =
      searchText1.length > 0 && employeedata?.length
        ? employeedata.filter((item) => {
            return (
              item &&
              Object.keys(item).some((key) => {
                const value = item[key];
                return (
                  value !== null &&
                  value
                    .toString()
                    .toLowerCase()
                    .includes(searchText1.toLowerCase())
                );
              })
            );
          })
        : employeedata;

 
  return (
    <>
      <Menubar />
      <Container fluid  className='map-header1'  >
        <div className='sa-title'>
          <h2>Population <span> Report</span></h2>
        </div>
      </Container>

      <DESUI.Container fluid style={{ width: "87%" }} className="outer-page-content-container">
        <Row>
              <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
                <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px", }} onFocus={(e) => { e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; e.currentTarget.style.border = "1px solid #353935"; e.currentTarget.style.width = "100%"; }} onBlur={(e) => { e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; e.currentTarget.style.border = "1px solid #ddd"; e.currentTarget.style.width = "150px"; }} >
                  <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible", }} /> <input type="text" placeholder="Search " value={searchText1} onChange={(event) => setSearch1(event.target.value)} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0", }} /> </div>
              </Col>

                 <Col className=" mb-2 " > <button className="btn btn-danger btn-sm mx-2 pdf-btn" onClick={() => generatePdf("#my-table", "Population Report",uniqueYears.length+2)} style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button> <button variant="success" size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToExcel("my-table", "Population Report")} > Excel<AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
              
                                  </Col>
            </Row>
              <div style={{ textAlign: "center", backgroundColor: "#d4e3d8" }} className="rounded-1 border py-2 px-2 " >
                     <span className="style-1">Population Report</span> <div className="text-end style-1">Report On : {currentdate} {currenttime}</div>        
                  </div>
            <div id="table-scroll"className="table-scroll">
              <div className="table-wrap">

            <table bordered hover id="my-table" className="custom-table table-responsive  table-striped table table-bordered" >
                <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
                  
                  <tr className="text-center only-export">
                  <th colSpan={uniqueYears.length+2} style={{ backgroundColor: "#d4e3d8", color: "black" }}>
                    <span className="style-1">Population Report </span>
                 </th></tr>

                  <tr className="only-export"><th  colSpan="9"><div className="text-end style-1">Report On : {currentdate} {currenttime}</div></th></tr>
                  <tr className="text-center">

      <th rowSpan={2}>Sl No.</th>
      <th rowSpan={2}>District</th>
      <th colSpan={uniqueYears.length}>Population (In Lakhs)</th>
    </tr>
    <tr>
    {Array.isArray(uniqueYears) && uniqueYears.map((year, index) => (
    <th key={index}>{year}</th>
  ))}
    </tr>
                </thead>
                <tbody>
  {filteredDataa?.length === 0 || filteredDataa === undefined ? (
    <tr>
      <td className="text-center" colSpan={uniqueYears.length+2}>
        <b style={{ color: "red" }}>Details Not Found</b>
      </td>
    </tr>
  ) : (
    (() => {
      // Step 1: Group records by district_name
      const districtMap = {};
      filteredDataa.forEach(item => {
        if (!districtMap[item.district_name]) {
          districtMap[item.district_name] = [];
        }
        districtMap[item.district_name].push(item);
      });

      // Step 2: Generate table rows
      return Object.entries(districtMap).map(([districtName, records], i) => (
        <tr key={i}>
          <td style={{ textAlign: "center" }}>{i + 1}</td>
          <td>{districtName}</td>
          {uniqueYears.map((year, yIndex) => {
            const yearData = records.find(r => r.fin_year === year);
            return (
              <td key={yIndex} style={{ textAlign: "right" }}>
                {yearData ? yearData.population : "-"}
              </td>
            );
          })}
        </tr>
      ));
    })()
  )}
</tbody>



              </table>

</div>
            </div>

           

<AlertModal
        show={showAlert}
        titleText={alertData.titleText}
        alertText={alertData.alertText}
        onClose={closeAlert}
      />
      </DESUI.Container >
    </>
  );
};



